import React from 'react'
import { GroupContainer } from '../GroupContainer'
import { SummaryItem } from '../SummaryItem'
import { useSummaryDetailsViewModel } from '../../../hooks/useSummaryDetailsViewModel'
import { useTranslation } from '../../../../../utils/convergence'
import { Divider } from '@afterpaytouch/core'
import styles from './style.module.css'

export const PaylaterSection = (): JSX.Element => {
  const { t } = useTranslation()
  const { financedItems, totalInterestAmount, totalAmount } = useSummaryDetailsViewModel()
  const isExpandable = financedItems.length >= 2

  return (
    <GroupContainer name={t('summary:payLater')} amount={totalAmount} expandable={isExpandable} testNameSpace='pay-later'>
      {financedItems.map((item, index) => (
        <SummaryItem
          key={item.id}
          id={item.id}
          index={index}
          name={item.name}
          amount={item.price}
          downPaymentAmount={item.downPaymentAmount}
          testNameSpace='pay-later'
        />
      ))}
      <Divider margin='Regular' />
      <SummaryItem id='interest' name={t('summary:interest')} amount={totalInterestAmount} testNameSpace='pay-later' />
      <SummaryItem id='total-amount' bold name={t('summary:planAmount')} amount={totalAmount} testNameSpace='pay-later' />
      <div className={styles.spacer} />
    </GroupContainer>
  )
}
